import saveAs from 'file-saver';

const confirmExitPage = ev => {
  ev.preventDefault();

  const warningMessage =
    'Loom is still downloading. Are you sure you want to leave?';

  ev.returnValue = warningMessage;

  return warningMessage;
};

class DownloadProgress {
  constructor(onProgressCallback, onCompletedCallback, onErrorCallback) {
    this.onProgressCallback = onProgressCallback;
    this.onCompletedCallback = onCompletedCallback;
    this.onErrorCallback = onErrorCallback;
  }

  setTime = () => {
    this.time = this.time || 0;
    this.time++;
  };

  onProgress = ev => {
    const percentProgress = (ev.loaded * 100) / ev.total;
    const roundedProgress = Math.floor(percentProgress);

    this.onProgressCallback(`${roundedProgress}`);
  };

  onLoad = ev => {
    const target = ev.target;

    const type = target.getResponseHeader('Content-Type');
    const blob = new Blob([target.response], { type });

    this.downloadData = blob;

    clearInterval(this.timerInterval);

    window.removeEventListener('beforeunload', confirmExitPage);

    this.onCompletedCallback(this.fileName);
  };

  onError = ev => {
    this.cleanup();
    this.onErrorCallback(ev);
  };

  fetch(url = '', filename = null) {
    this.fileName = filename || url.split('/').pop();

    this.request && this.request.abort();

    this.request = new XMLHttpRequest();

    this.request.addEventListener('progress', this.onProgress);
    this.request.addEventListener('load', this.onLoad);
    this.request.addEventListener('error', this.onError);

    window.addEventListener('beforeunload', confirmExitPage);

    this.request.open('GET', url);

    this.request.responseType = 'blob';

    this.request.send();

    clearInterval(this.timerInterval);

    this.time = 0;
    this.timerInterval = setInterval(this.setTime, 1000);
  }

  abort() {
    this.request && this.request.abort();
    this.cleanup();
  }

  cleanup() {
    this.request = null;
    this.fileName = null;
    this.downloadData = null;

    clearInterval(this.timerInterval);

    window.removeEventListener('beforeunload', confirmExitPage);
  }

  save = () => saveAs(this.downloadData, this.fileName);
}

export default DownloadProgress;
